/* eslint-disable no-console */
const fixedMenu = (options) => {
  const { offsetDiv, menuDiv } = options;
  if (!offsetDiv || !menuDiv) {
    return;
  }
  let offset = offsetDiv.offsetHeight;
  const fixedSelector = 'fixed';
  // Update offset on resize
  window.addEventListener('resize', () => {
    const hasSelector = menuDiv.classList.contains(fixedSelector);
    if (!hasSelector && offsetDiv.offsetHeight > 0) {
      offset = offsetDiv.offsetHeight;
    }
  });
  // user setInterval, not scroll event listener
  setInterval(() => {
    const { scrollY } = window;
    const hasSelector = menuDiv.classList.contains(fixedSelector);
    if (scrollY >= offset && !hasSelector) {
      // Add fixed class to menu
      menuDiv.classList.add(fixedSelector);
    } else if (scrollY < offset && hasSelector) {
      menuDiv.classList.remove(fixedSelector);
    }
  }, 100);
};

export default fixedMenu;
/* eslint-enable no-console */
